/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_Modified_ByInputs */

const en_tables_custom_pages_modified_by = /** @type {(inputs: Tables_Custom_Pages_Modified_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages Modified By`)
};

const de_tables_custom_pages_modified_by = /** @type {(inputs: Tables_Custom_Pages_Modified_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert von`)
};

/**
* | output |
* | --- |
* | "Pages Modified By" |
*
* @param {Tables_Custom_Pages_Modified_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_modified_by = /** @type {((inputs?: Tables_Custom_Pages_Modified_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_Modified_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_modified_by(inputs)
	return de_tables_custom_pages_modified_by(inputs)
});